import React, { useEffect } from "react";
import PropTypes from "prop-types";
import "components/BottomUpModal/BottomUpModal.css";
import {
  disablePageScroll,
  enablePageScroll,
  stopPropagationFunction,
} from "utils/commonMethods";
import { CrossIcon } from "constants/icons";

//Modal that animates up from the bottom of screen.
function BottomUpModal({
  open,
  modalTitle,
  closeHandler,
  children,
  showCrossIcon = true,
}) {
  let parentClassName = "bottom-to-up-modal__wrapper";

  //Transparents the background color of page and enables onClose on it.
  useEffect(() => {
    if (open) {
      disablePageScroll();
    } else {
      enablePageScroll();
    }
    return enablePageScroll;
  }, [open, closeHandler]);

  //Appends class to show modal on screen.
  if (open) {
    parentClassName += " show-modal";
  }

  return (
    <div className={open ? "transparent-overlay" : ""} onClick={closeHandler}>
      <div className={parentClassName} onClick={stopPropagationFunction}>
        <div className="bottom-to-up-modal__title-wrapper">
          <label className="title-wrapper--title">{modalTitle}</label>
          {closeHandler && (
            <div
              onClick={closeHandler}
              className="cursor-pointer bottom-to-up-modal__close-icon"
              style={{ visibility: showCrossIcon ? "visible" : "hidden" }}
            >
              <i>
                <CrossIcon />
              </i>
            </div>
          )}
        </div>
        {open && children}
      </div>
    </div>
  );
}

BottomUpModal.propTypes = {
  open: PropTypes.bool.isRequired,
  modalTitle: PropTypes.string,
  closeHandler: PropTypes.func,
  children: PropTypes.any,
  showCrossIcon: PropTypes.bool,
};

export default BottomUpModal;
